import type { Annotation } from 'fhir/r4';

import { type ResourceNote, ResourceNoteSchema } from './schema';

export const addResourceNote = (
  resourceNotes: Annotation[] | undefined,
  newNote: ResourceNote,
): Annotation[] =>
  resourceNotes
    ? [...resourceNotes, mapResourceNoteToFhir(newNote)]
    : [mapResourceNoteToFhir(newNote)];

export const mapResourceNoteToFhir = (
  note: ResourceNote,
): fhir4.Annotation => ({
  text: note.text,
  authorReference: note.author,
  time: note.time,
});

export const mapFhirToResourceNote = (
  annotation: fhir4.Annotation,
): ResourceNote | undefined => {
  const { authorReference, text, time } = annotation;

  const result = ResourceNoteSchema.safeParse({
    author: authorReference,
    text,
    time: time ? time : undefined,
  });

  if (!result.success) {
    return;
  }

  return result.data;
};
